import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `الصفحة الرئيسية لدردشة ${ctx.brand} المجهولة`,
    languageButtonLabel: `اللغة`,
    languageModalTitle: `اختر لغة`,
    languageModalCloseLabel: `إغلاق قائمة اللغات`,
  },
  languageOptions: {
    'en-US': {
      label: `الإنجليزية (الولايات المتحدة)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `الإنجليزية (كينيا)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `الإنجليزية (نيجيريا)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `الإنجليزية (سنغافورة)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `البرتغالية (البرتغال)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `البرتغالية (البرازيل)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `الألمانية (ألمانيا)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `الألمانية (النمسا)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `الألمانية (سويسرا)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `الإسبانية (إسبانيا)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `الفرنسية (فرنسا)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `الإيطالية (إيطاليا)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `الهولندية (هولندا)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `البولندية (بولندا)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `السويدية (السويد)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `الدانمركية (الدانمرك)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `الفنلندية (فنلندا)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `النرويجية (النرويج)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `الأيسلندية (آيسلندا)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `اليابانية (اليابان)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `الكورية (كوريا الجنوبية)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `الصينية (الصين)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `الكَنْتُونية (هونغ كونغ الصينية (منطقة إدارية خاصة))`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `الفيتنامية (فيتنام)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `التايلاندية (تايلاند)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `الإندونيسية (إندونيسيا)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `السواحيلية (كينيا)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `الهندية (الهند)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `البنغالية (بنغلاديش)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `الماراثية (الهند)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `التيلوجو (الهند)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `الفارسية (إيران)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `الأوردية (باكستان)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `البنجابية (باكستان)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `البدجنية النيجيرية (نيجيريا)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `الروسية (روسيا)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `العربية (المملكة العربية السعودية)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `العربية (الإمارات العربية المتحدة)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `العربية (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `الدارجة المغربية (المغرب)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `التركية (تركيا)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `اختر لغة`,
    closeLabel: `إغلاق قائمة اللغات`,
  },
  languageHint: (ctx) => `تنقل بين ${ctx.localesCount}+ لغات من غير ما تنشئ حساب.`,
  readPagePrompt: ({languageLabel}) => `اقرأ هذه الصفحة بـ${languageLabel}.`,
};
